import { Map } from 'immutable';
import { actionTypes as EditTerminologyDialogActions } from '../../../actions/Administration/SettingsPage/Dialogs/editTerminologyDialogActions';

let defaultState = {
  show: false,
  loading: false,
  itemToEdit: null,
  dialogData: null,
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {
    case EditTerminologyDialogActions.EDIT_TERMINOLOGY_DIALOG_SHOW:
      state = state.set('itemToEdit', action.payload);
      return state.set('show',true);

    case EditTerminologyDialogActions.EDIT_TERMINOLOGY_DIALOG_HIDE:
      return Map(defaultState);

    case EditTerminologyDialogActions.EDIT_TERMINOLOGY_DIALOG_SUBMIT_IN_PROGRESS:
      return state.set("loading", true);

    case EditTerminologyDialogActions.EDIT_TERMINOLOGY_DIALOG_SUBMIT_FINISHED:
      return state.set("loading", false);

    case EditTerminologyDialogActions.EDIT_TERMINOLOGY_DIALOG_FETCH_DATA_READY:
      return state.set("dialogData", action.payload);

    default:
      return state;
  }

}







